// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hamburger[data-v-4e6f274c] {\n  display: inline-block;\n  vertical-align: middle;\n  /* width: 20px;\n  height: 20px; */\n  font-size: 22px;\n  /* color: white; */\n  color: rgba(255, 255, 255, 0.9);\n}\n.hamburger.is-active[data-v-4e6f274c] {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}", ""]);
// Exports
module.exports = exports;
